/**
 * A game against the sparring partner: /tools/play.
 *
 * The board is a session of its own (`boards.play`) and the engine is the service; this is what the
 * page shows about the game — whose turn it is, whether the partner is thinking, and how it ended.
 */
export const playSlice = {
    // idle: nothing started | playing | finished
    status: "idle",
    side: "white",        // the side the user plays, decided when the game starts
    strength: "club",     // key of domain/playRules STRENGTHS: one rung, two possible partners
    source: "real",       // "real" (the moves players made) or "engine" (Stockfish at that rung)
    opening: null,        // slug of the catalog opening the game starts in; null is move one
    openings: null,       // the openings there are to choose from, once the catalog has been read
    fromPly: 0,           // plies dealt before the game began: an opening is not your play
    // Who has been answering: { source, using, book, engine, handover }
    partner: { source: "real", using: null, book: 0, engine: 0, handover: null },
    thinking: false,      // the partner is looking for its move
    paused: false,        // the game is stopped to look at the position: nothing moves while it is
    outcome: null,        // { over, result, reason, winner, verdict } once it is over
    xp: 0,                // what the finished game was worth
    saved: false,         // the game reached the account (or this device, for a visitor)
    pgn: null,            // the finished game, for the file and for Lichess
    fen: null,            // where it ended
    error: null,
    // Looking at the game afterwards: the same verdicts the study gives, one per move of yours
    review: { status: "idle", done: 0, total: 0, verdicts: {}, accuracy: null },
};
